module.exports = __webpack_public_path__ + "img/add-comment-logo.d0936e5b.png";